import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = [
  {"section": "Skin", "questions": ["Skin type", "Skin tone", "Active concerns", "Recent treatments"]},
  {"section": "Allergies", "questions": ["Product allergies", "Past reactions"]},
];

export default function PublicConsultation() {
  const { project_id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [f, setF] = useState({ client_name: '', client_phone: '' });
  const [done, setDone] = useState(false);
  useEffect(() => {
    axios.get(`${BACKEND}/api/consultation-questions`).catch(() => ({ data: DEFAULTS })).then(r => setQuestions(r?.data || DEFAULTS));
  }, []);
  const submit = async () => {
    if (!f.client_name) { toast.error('Please enter your name'); return; }
    await axios.post(`${BACKEND}/api/public/consultation/${project_id}`, { ...f, answers });
    setDone(true);
  };
  if (done) return <div className="min-h-screen flex items-center justify-center px-6"><div className="text-center"><div className="serif text-[26px]">Thank you.</div><div className="text-sm text-[var(--muted)] mt-2">Your responses have been saved.</div></div></div>;
  return (
    <div className="min-h-screen py-8 px-4" style={{background:'var(--cream)'}}>
      <Toaster position="top-center" richColors/>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="serif text-[32px]">Bridal Consultation</div>
          <div className="eyebrow mt-2">Rishika Sharma</div>
          <div className="gold-rule my-4 mx-auto" style={{width:60}}/>
          <div className="text-sm text-[var(--muted)]">A short form so I can prepare for your day. Please answer as much as you're comfortable with — nothing here is shared.</div>
        </div>
        <div className="card-cream p-5 mb-4">
          <div className="grid grid-cols-2 gap-3">
            <div><label className="eyebrow">Your name</label><input value={f.client_name} onChange={e => setF({...f, client_name: e.target.value})} data-testid="consultation-name"/></div>
            <div><label className="eyebrow">Phone</label><input value={f.client_phone} onChange={e => setF({...f, client_phone: e.target.value})}/></div>
          </div>
        </div>
        {questions.map((sec, si) => (
          <div key={si} className="card-cream p-5 mb-4">
            <div className="eyebrow mb-3">{sec.section}</div>
            <div className="space-y-3">
              {sec.questions.map((q, qi) => (
                <div key={qi}>
                  <label className="text-sm">{q}</label>
                  <textarea rows={2} value={answers[`${sec.section}__${qi}`]||''} onChange={e => setAnswers({...answers, [`${sec.section}__${qi}`]: e.target.value})} data-testid={`consultation-${si}-${qi}`}/>
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className="card-cream p-5 mb-6">
          <label className="eyebrow">Anything else you'd like me to know</label>
          <textarea rows={4} value={answers.other||''} onChange={e => setAnswers({...answers, other: e.target.value})}/>
        </div>
        <button className="btn-gold w-full" onClick={submit} data-testid="consultation-submit">Submit</button>
      </div>
    </div>
  );
}
